export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0009s_0000_Black-&-White-17.9e38b91e.png";